{
  "paid-by-borrower": "Paid by Borrower",
  "paid-by-seller": "Paid by Seller",
  "description": "Description",
  "payee": "Payee",
  "at-closing": "At Closing",
  "before-closing": "Before Closing",
  "by-others": "By Others",
  "totals": "Totals",
  "additional-row": "Additional Row",
  "clear": "Clear",
  "charges": "Charges",
  "prepaids": "Prepaids",
  "escrow": "Escrow",
  "lender-credits": "Lender Credits",
  "debits-and-credits": "Debits And Credits",
  "days_per_year": "Days per year",
  "edit-premium-line": "Edit Premium Line In Policy Information",
  "interest-rate": "Interest Rate",
  "addendum": "Addendum",
  "k-due-borrower": "K. Due from Borrower at Closing",
  "adjustments": "Adjustments",
  "adjustments-for-items": "Adjustments for Items Paid by Seller in Advance",
  "m-due-seller": "M. Due to Seller at Closing",
  "statement-text": "Statement Text",
  "l-paid-already": "L. Paid Already by or on Behalf of Borrower at Closing",
  "other-credits": "Other Credits",
  "adjustments-for-items-updaid": "Adjustments for Items Unpaid by Seller",
  "deposit": "Deposit",
  "loan-amount": "Loan Amount",
  "lender": "Lender",
  "settlement-agency": "Settlement Agency",
  "other": "Other",
  "none": "None",
  "n-due-seller": "N. Due from Seller at Closing",
  "label": "Label",
  "payments": "Payments",
  "payment": "Payment",
  "routing": "Routing",
  "account": "Account",
  "reference": "Reference",
  "transfer": "Transfer",
  "holdback": "Holdback",
  "check": "Check",
  "wire": "Wire",
  "net-funded": "Net Funded",
  "aggregate": "Aggregate",
  "current-total": "Current Total",
  "add-document": "Add Document",
  "per-month": "per Month",
  "number-of-month": "# of Mo.",
  "to-others": "To Others",
  "send-title-charges-to": "Send Title Charges to",
  "summary-jk": "Summary of Transactions",
  "gross-amount-due": "Gross Amount Due from Borrower",
  "gross-due-seller": "Gross Amount Due to Seller",
  "no-disbursements-yet": "No disbursements Yet",
  "payment-details": "Payment Details",
  "add-disbursement": "Add Disbursement",
  "no-items-to-show": "No items to show",
  "remove-association": "Remove Payer",
  "edit-association": "Edit Payer",
  "error-loading-document-charges": "We have an error while try to get the information from the document",
  "charges-collected": "Information Collected from the Document",
  "verify-charges": "Please Verify before add it to the Order, the charges marked with blue already are in the order",
  "add-entry": "Add Entry",
  "select-payees": "Select Payees",
  "select-payers": "Select Payers",
  "select-parties": "Select Parties",
  "select-proprietors": "Select Proprietors",
  "select-ownerships": "Select Ownerships",
  "toggleParties": "Show parties",
  "noEntries": "No entries yet",
  "noParties": "No parties assigned yet",
  "update-charges": "Update Charges",
  "success-updated": "Charges Updated",
  "error-updated": "Error updating charges",
  "success-deleted": "Charge successfully deleted",
  "error-deleted": "Error deleting charge",
  "commissions":"Commissions",
  "charges-before":"The charges marked in blue were already on the order and cannot be deleted until the system screens. The charges that are on the document appear afterward.",
  "deleteChargeTitle": "Delete Charge",
  "deleteChargeConfirmation": "Are you sure you want to delete this charge? This action cannot be undone, and all associated information will be lost.",
  "document-deleted": "Document Deleted",
  "edit-document": "Edit Document",
  "add-document": "Add Document",
  "amount-details": "Amount Details",
  "closing-cost-subtotal": "Closing Cost Subtotal",
  "paymentInfo": "Payment Info",
  "partySearchAndCreation": "Party search and creation (for those not already in the order or the system)",
  "partiesSelected": "Parties Selected",
  "beforeClosing": "Before Closing",
  "atClosing": "At Closing",
  "pricesOfTDISelected": "Prices of the TDI selected:",
  "txLabel": "TX",
  "chargeSettings": "Charge Settings",
  "addNew": "Add New",
  "priceOfFirstPage": "Price of first Page",
  "pricePerPage": "Price per Page",
  "extraPages": "Extra Pages",
  "priceOfAdditionalPages": "Price of Additional Pages",
  "namesIncluded": "Names Included",
  "pricePerExtraName": "Price per extra Name",
  "priceOfAdditionalNames": "Price of Additional Names",
  "endorsement": "Endorsement",
  "paidByBorrower": "Paid By Borrower",
  "paidBySeller": "Paid By Seller",
  "document": "Document",
  "amount": "Amount",
  "totalAmount": "Total Amount",
  "chargeDetails": "Charge Details",
  "showDetails": "Show details",
  "hideDetails": "Hide details",
  "buyerAtClosing": "Buyer at closing",
  "buyerBeforeClosing": "Buyer before closing",
  "sellerAtClosing": "Seller at closing",
  "sellerBeforeClosing": "Seller before closing",
  "months": "Months",
  "tax": "Tax",
  "endorsementCode": "Code: {{code}}",
  "deleteChargeAriaLabel": "Delete charge",
  "changePayers": "Change Payers",
  "changePayees": "Change Payees",
  "noPayees": "No payees set",
  "noPayers": "No payers set",
  "changeTaxes": "Change Taxes",
  "noTaxes": "No taxes set",
  "mobileStepSelectCharges": "Select Charges",
  "mobileStepSelectParties": "Select Parties",
  "mobileStepConfigureAmounts": "Configure Amounts",
  "mobileStepReviewCharges": "Review Charges",
  "mobileSelectedCount": "{{count}} selected",
  "mobileSearchParties": "Search parties",
  "mobileReviewChargesTitle": "Charges to Update",
  "change-all": "Change all:",
  "taxes": "Taxes",
  "tab-origination-charges": "Origination Charges",
  "tab-did-not-shop-for": "Did Not Shop For",
  "tab-did-shop-for": "Did Shop For",
  "tab-taxes-and-fees": "Taxes and Fees",
  "tab-prepaids": "Prepaids",
  "tab-escrow": "Escrow",
  "tab-other-charges": "Other Charges",
  "tab-lender-credits": "Lender Credits",
  "tab-debits-and-credits": "Debits and Credits",
  "tab-summary-of-transactions": "Summary of Transactions",
  "tab-commissions": "Commissions",
  "tab-loan-charges": "Loan Charges",
  "tab-prepaid-items": "Prepaid Items",
  "tab-impounds": "Impounds",
  "tab-title-charges": "Title Charges",
  "tab-recording-charges": "Recording Charges",
  "tab-additional-charges": "Additional Charges"
}
